import axiosInstance from "./axiosInstance";

export const getQuickAccessItems = async (locale = "en") => {
  const res = await axiosInstance.get(
    `/api/quick-access-items?locale=${locale}&sort=order`
  );

  return res.data.data.map((item) => ({
    id: item.id,
    title: item.title,
    description: item.description,
    redirectPath: item.redirectPath,
    iconKey: item.iconKey,
    iconName: item.iconName,
    iconColor: item.iconColor,
    order: Number(item.order),
  }));
};
